import React                            from 'react';
import { Observe }                      from 'rewire-core';
import SettingsModel                    from './SettingsModel';
import { Theme, makeStyles }            from '../utility/styles';
import {
  DefaultEditPanelView,
}                                       from './DefaultSettingsView';
import { IInfoPanelProps }              from '../ui/InfoPanel';
import ArchiveDeleteAreaDialog          from './ArchiveDeleteAreaDialog';

const useAreaEditPanelViewStyles = makeStyles((_theme: Theme) => ({
  infoPanelRoot: {
  },
}));

const AreaEditPanelView = ({ settings, classes, InfoPanelProps }: { settings: SettingsModel, classes?: any, InfoPanelProps?: IInfoPanelProps }) => {
  const areaEditPanelClasses = useAreaEditPanelViewStyles({classes});
  return <Observe render={() => (
    <>
    <DefaultEditPanelView InfoPanelProps={InfoPanelProps} settings={settings} classes={areaEditPanelClasses} />
    <ArchiveDeleteAreaDialog />
    </>
  )} />;
};

export default AreaEditPanelView;